// Two-step login (#1724, design/2026-10-27-mfa.md): where a person sets up
// an authenticator app, what the sign-in page then asks, and where a Manager
// resets it. It outlines and never clicks: setting up or resetting changes
// the account.

import type { Walkthrough } from './types'

export const twoStepLogin: Walkthrough = {
  slug: 'two-step-login',
  title: 'Two-step login',
  summary:
    'Shows where you set up two-step login (a code from an authenticator app after your password), what the sign-in page asks for, and where a Manager resets it. Nothing is set up or reset.',
  issue: '#1724',
  added: '2026-10-27',
  steps: [
    {
      page: 'admin-password',
      feature: 'account/two-step-login',
      say: 'Two-step login sits below Change Password. Set up two-step login shows a QR code to scan with an authenticator app; the first code from the app turns it on, and then 10 recovery codes are shown, once.',
    },
    {
      page: 'admin-password',
      feature: 'account/two-step-login',
      say: 'From then on the sign-in page asks for the code from the app after the password. Remember this browser for 30 days asks less often; a password change or a reset forgets every remembered browser. Use a recovery code is for a day without the phone.',
    },
    {
      page: 'admin-users',
      feature: 'people/reset-two-step-login',
      say: 'Lost phone and lost codes: a Manager opens the person’s ⋮ here and chooses Reset two-step login…. They are signed out, and the reset is recorded with who did it. Everyone else sees the item disabled, with the reason.',
    },
  ],
}
